import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MANUALLY_PROMOTED_PETITION_DATA = defineFcm('manually_promoted_petition_data')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				petition_ids: {
					type: 'array',
					shape: {
						type: 'number',
					},
				},
				percent: {
					type: 'number',
				},
				channels: {
					type: 'array',
					shape: {
						type: 'string',
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'promotion-service',
		context: 'Promoted Petitions',
		description: `Manually prioritize promoted petitions to be displayed per channel.

			Priority is given to matching locales (constructed as prefix from locale + country_code), then country of the user.
			As an example, a Greek user with locale 'en-US' and country_code 'GR', will construct a locale of en-GR, which does not match
			any of our supported locales, we will then attempt to lookup the config for the country, in this case 'GR'.

			Petitions set in countries should be in the default language of the country.

			Percent (0 to 1) controls how often the petitions will be prioritized ie. 1 being 100%, 0.1 10%.`,
		template: {
			petition_ids: [123, 456],
			percent: 1,
			channels: ['psf_carousel', 'petition_footer', 'petition_signer_receipt_email', 'petition_update_email'],
		},
	});
